module.exports = __webpack_public_path__ + "MMDGF.pdf?859325afde46ff441a11cb9ac5202778";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MMDGF.pdf
// module id = 56
// module chunks = 0